import currentUserStore from 'stores/CurrentUserStore';
import { isAuth0Flow } from '../../authProvider';

export const requirements = {
  requiredPermissions: ['Admin', 'SuperAdmin'],
  marqetaOnly: true,
};

export const verifier = () => {
  if (isAuth0Flow()) return false;

  const allowed = ['Admin', 'SuperAdmin'];
  const isMarqetan =
    currentUserStore.userStore.userOrgName && currentUserStore.userStore.userOrgName === 'Marqeta';
  return !!isMarqetan && allowed.includes(currentUserStore.userStore.permissionLevel);
};
